export default __webpack_public_path__ + "26973b3b2c8d71aa660a8f8f0bebbf41.png";